import React from "react";
import { LinearProgress, Grid2 as Grid } from "@mui/material";
import { Cause } from "../../../shared/types";
import { Item } from ".";

export interface CollectionProps {
  busy: boolean;
  causes: Cause[];
  handleSelect: (cause: Cause) => void;
}

export const Collection = ({
  busy,
  causes,
  handleSelect,
}: CollectionProps): React.JSX.Element => {
  return (
    <Grid size={{ xs: 12 }} container spacing={2}>
      {busy && (
        <Grid size={{ xs: 12 }}>
          <LinearProgress />
        </Grid>
      )}
      {causes.map((cause: Cause) => {
        return (
          <Item
            key={cause.id}
            cause={cause}
            handleSelect={() => {
              handleSelect(cause);
            }}
          />
        );
      })}
    </Grid>
  );
};
